import EmitenteRestricaoService from "@/services/EmitenteRestricaoService";

export const emitenteRestricao = {
  namespaced: true,
  state: {
    emitenteRestricao: {},
  },
  actions: {
    getEmitenteRestricao({ commit }, payload) {
      return EmitenteRestricaoService.GetEmitenteRestricao(payload).then(
        (emitenteRestricao) => {
          return Promise.resolve(emitenteRestricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEmitenteRestricao({ commit }, payload) {
      return EmitenteRestricaoService.PostEmitenteRestricao(payload).then(
        (emitenteRestricao) => {
          return Promise.resolve(emitenteRestricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEmitenteRestricao({ commit }, payload) {
      return EmitenteRestricaoService.PutEmitenteRestricao(payload).then(
        (emitenteRestricao) => {
          return Promise.resolve(emitenteRestricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEmitenteRestricao({ commit }, payload) {
      return EmitenteRestricaoService.DeleteEmitenteRestricao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEmitenteRestricaoOData({ commit }, payload) {
      return EmitenteRestricaoService.GetEmitenteRestricaoOData(payload).then(
        (emitenteRestricao) => {
          return Promise.resolve(emitenteRestricao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    liberarAcesso({ commit }, payload) {
      return EmitenteRestricaoService.LiberarAcesso(payload).then(
        (emitenteRestricao) => {
          return Promise.resolve(emitenteRestricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default emitenteRestricao;
